export default "//cdn.scentbird.com/assets/frontbird-site/images/spice-market_8660b3.jpg";